import { render } from "./DInputGroup.vue?vue&type=template&id=704a5ef0"
import script from "./DInputGroup.vue?vue&type=script&lang=js"
export * from "./DInputGroup.vue?vue&type=script&lang=js"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__